import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { Helmet } from "react-helmet";
import { Card, CardBody, Col, Row, Container, Label, FormGroup } from "reactstrap";

import editIcon from "../../assets/images/app/digiPub/account-circle.svg";
import successModal from "../../assets/images/app/plate-talk/success-modal-icon.svg";

import { CustomButton } from "../../components/CustomButton";
import { updateProfileValidationSchema } from "./FormValidations";
import { ImageBox } from "../../components/ImageBox";
import { EditableDetail } from "../../components/EditableDetail";
import { PageTitles } from "../../constants";
import APP_CONFIG from "../../APP_CONFIG";
import FormikErrorText from "../../components/FormikErrorText/FormikErrorText";
import { TextInput } from "../../components/Input";
import { NAMES, PLACEHOLDERS } from "./AccountFieldsNames";
import { ConfirmationModal, InformationModal } from "../../components/CustomModal";

const Profile = ({ FIELDS_TITLE = {}, onSubmitHandling = () => {}, isLoading }) => {
    let { FULL_NAME, EMAIL, PHONE_NUMBER } = FIELDS_TITLE;
    const { FullName, Email } = useSelector((store) => store?.userAuth?.user);

    const [editProfile, setEditProfile] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            fullName: "John Smith",
            email: "john@mail.com",
            phoneNumber: "+1 232 324352"
        },
        validationSchema: updateProfileValidationSchema,
        onSubmit: (values) => {
            // onSubmitHandling(values);
            setEditProfile(true);
        }
    });

    return (
        <div className="">
            <Helmet>
                <title>{PageTitles.ACCOUNT}</title>
            </Helmet>

            <Card className="custom-card mt-3">
                <form onSubmit={formik.handleSubmit}>
                    <Container fluid>
                        <CardBody className="account-responsiveness">
                            <Row>
                                <Col md={4}>
                                    <TextInput
                                        placeholder={PLACEHOLDERS[EMAIL]}
                                        label={EMAIL}
                                        name={NAMES[EMAIL]}
                                        type={NAMES[EMAIL]}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values[NAMES[EMAIL]]}
                                        labelClass="custom-label mb-0"
                                        className="hide-default-icon text-input"
                                        disabled={true}
                                        autoFocus
                                    />
                                    <FormikErrorText
                                        formikInstance={formik}
                                        fieldName={NAMES[EMAIL]}
                                        className="error"
                                    />
                                </Col>
                                <Col md={4}>
                                    <TextInput
                                        placeholder={PLACEHOLDERS[FULL_NAME]}
                                        label={FULL_NAME}
                                        name={NAMES[FULL_NAME]}
                                        type={NAMES[FULL_NAME]}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values[NAMES[FULL_NAME]]}
                                        labelClass="custom-label mb-0"
                                        className="hide-default-icon text-input"
                                        autoFocus
                                    />

                                    <FormikErrorText
                                        formikInstance={formik}
                                        fieldName={NAMES[FULL_NAME]}
                                        className="error"
                                    />
                                </Col>

                                <Col md={4}>
                                    <TextInput
                                        placeholder={PLACEHOLDERS[PHONE_NUMBER]}
                                        label={PHONE_NUMBER}
                                        name={NAMES[PHONE_NUMBER]}
                                        type={NAMES[PHONE_NUMBER]}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values[NAMES[PHONE_NUMBER]]}
                                        labelClass="custom-label mb-0"
                                        className="hide-default-icon text-input"
                                        autoFocus
                                    />
                                    <FormikErrorText
                                        formikInstance={formik}
                                        fieldName={NAMES[PHONE_NUMBER]}
                                        className="error"
                                    />
                                </Col>
                            </Row>
                            <Row className="d-flex justify-content-end">
                                <Col sm="12" md="3" lg="3" className="d-flex justify-content-end">
                                    <CustomButton
                                        loading={false}
                                        type={"submit"}
                                        title="Update Profile"
                                        color="primary"
                                        className="custom-btn-md  mt-2 grad-primary"
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Container>
                </form>
            </Card>

            <ConfirmationModal
                size="md"
                hasCustomConfig
                isOpen={editProfile}
                customImageSrc={editIcon}
                customTitle={"Update User Profile"}
                customSubText={"Are you sure you want to update your profile?"}
                customYesBtnText={"Update"}
                customNoBtnText={"Cancel"}
                onNo={() => {
                    setEditProfile(false);
                }}
                onYes={() => {
                    // Implement the action to take on confirmation
                    setEditProfile(false);
                    setShowModal(true);
                }}
            />

            <InformationModal
                size="md"
                isOpen={showModal}
                Title={"Your user profile has been updated successfully"}
                confirmButtonText="Done"
                ImageSrc={successModal}
                onConfirmClick={() => setShowModal(false)}
            />
        </div>
    );
};

export default Profile;
